export enum RISK_LEVEL {
  NONE = 0,
  PERFECT = 1,
  HAS_RISK = 2,
  SERIOUS = 3
}

export const riskLevelArr = [
  { text: '优质无误', value: RISK_LEVEL.PERFECT },
  { text: '部分风险', value: RISK_LEVEL.HAS_RISK },
  { text: '完全错误', value: RISK_LEVEL.SERIOUS }
];

export interface ReviewSuggestion {
  value: number;
  result: string;
  reasons: string[];
}
export const REVIEWED_PHOTO_LOCAL_STORAGE_KEY =
  'my-pending-page-reviewed-photo';

export const LONG_PICTURES_PREVIEW_LOCAL_STORAGE_KEY = 'long-pictures-preview';

export const PICTURES_SET_PREVIEW_LOCAL_STORAGE_KEY = 'pictures-set-preview';

export interface GetTasksReqQuery {
  taskType: 1 | 2 | 3; // 1 待审核视频 2 待确认视频 3 已审核视频
  scrollType: 1 | 2 | 3; // 1 向后拉取 2 向前拉取 3 拉取前后
  // scrollType=1时，传上次请求的最后一个视频id（我已审核二级页上下滑）
  // scrollType=2时，传上次请求的第一个视频id
  // scrollType=3时，传从外面跳进来的视频id（我的待定、我已审核的二级页跳转）
  encryptedPhotoId?: string;
}

interface CDNUrlObj {
  cdn: string;
  url: string;
  freeTrafficCdn: boolean;
}

export interface PhotoView {
  encryptedPhotoId: string;
  photoType: 1 | 2 | 3 | 4; // 1 视频 2 单图 3 多图 4 长图
  caption: string;
  userId: string; // 作者uid
  userName: string; // 作者名称
  mainMvUrls: CDNUrlObj[];
  coverThumbnailUrls: CDNUrlObj[];
  imageUrls: Array<CDNUrlObj[]>;
  manifest: string; // 视频清单
}

export interface AuditVideo {
  taskId: number;
  photo: PhotoView;
  auditResult: AuditResult;
  /**
   * 是否经过省份校验
   */
  provinceVerified?: boolean;
}

export interface GetTasksResBody {
  pcursor: string; // 向上的游标，no_more代表没有前一页的作品
  bcursor: string; // 向下的游标，no_more代表没有下一页的作品
  auditVideos: AuditVideo[];
}

export interface GetRecordsReqQuery {
  recordType: 1 | 2; // 1:审核记录 2:待定记录
  lastDate?: string;
}

export interface AuditResult {
  relevant: boolean;
  result: 0 | 1 | 2 | 3; // 0 空 1 无风险 2 有风险 3 完全错误
  suggestion: string; // 补充建议
}

export interface RecordsDetail {
  photoId: number;
  photoDesc: string;
  photoCover: string;
  photoViewCount: number;
  photoType: 1 | 2 | 3 | 4;
  auditTs: number; // 审核时间戳 单位毫秒
  auditResult: AuditResult;
}

export interface VideoReviewRecord {
  date: string;
  details: RecordsDetail[];
}

export type VideoReviewRecords = VideoReviewRecord[];

export interface GetRecordsResBody {
  hasMore: boolean;
  records: VideoReviewRecords;
}

export interface ReviewPopupSubmitData {
  auditResult?: 0 | 1 | 2 | 3; // 0 空 1 无风险 2 有风险 3 完全错误
  suggestion?: string; // 补充建议
  videoContentType?: string;
  highQualityVideo?: boolean;
}

export type SubmitTaskReqBody = ReviewPopupSubmitData & {
  encryptedPhotoId: string;
  taskId: number;
};

export interface GetAuditEntranceResBody {
  enableAuditVideo: boolean;
  enableWorkTime: boolean;
}

export interface AuditTags {
  name: string;
  tags: {
    name: string;
    icon: string;
    subTags: {
      id: number;
      name: string;
      selected: boolean;
      defaultSelected: boolean;
    }[];
  }[];
}

export type GetAuditTagsResBody = AuditTags[];

export interface GetAuditConfigsResBody {
  /**
   * 审核意见列表
   */
  suggestions: ReviewSuggestion[];
  /**
   * 视频内容类型列表
   */
  videoContentTypes: string[];
  /**
   * 是否允许医生筛选省份
   */
  enableProvinceFilter?: boolean;
}

export interface GetVideoReviewProgressResBody {
  auditCount: number; // 本月累计审核
  rejectVideoCount: number; // 本月参与判罚视频数
  currentMonthRank: number;
  history: {
    month: string; // 月份
    auditCount: number; // 累计审核数
    rejectVideoCount: number; // 参与判罚视频数
    rank: number; // 审核量排名
  }[];
}

export interface ProvinceInfo {
  /**
   * 省份中文名
   */
  provinceName: string;
  /**
   * 省份拼音 全小写
   */
  provincePinYin: string;
  /**
   * 省份 id
   */
  provinceId: string;
  /**
   * 是否选中
   */
  selected: boolean;
}

export interface GetVideoReviewOptions {
  provinceInfos: ProvinceInfo[];
}
